// extracted by mini-css-extract-plugin
export default {"modal-confirmation__container":"styles_modal-confirmation__container__TYKPG","title":"styles_title__WCba4","description":"styles_description__4p1FC"};